//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from "vuex";
import { defaultBlockProps } from "~/helpers/data";

export default {
    name: "BowDetailsBlock",
    props: {
        ...defaultBlockProps,
    },
    data: () => ({}),
    computed: {
        ...mapState({
            info: ({ immobile }) => immobile.info,
        }),

        ...mapGetters(["immobile/getInfo"]),
    },
};
